import { Grid } from 'semantic-ui-react';
import { H2 } from '@styles/Global.styles';
import queryString from 'query-string';
import {
  getVehicleTypeByQueryString,
  getCombinationByQueryString,
  getTransactionTypeByQueryString,
  getIsGiftingByQueryString,
  isMobile,
  getCleanCampaignByQueryString,
  getRandomBinary,
  setEmptyIfUndefiendByQueryString,
  getDesignIdByQueryString,
} from '@utils/Helpers';
import {
  VehicleType,
  CurrentPlateDesign,
  VehicleTypesSetting,
  TransactionType,
  TransactionTypesSetting,
} from '~/dataModels/ProductModels';

import { GenericBannerContainer } from '~/components/GenericBannerContainer';
import { HeaderStep } from '~/components/SelectStyle/SelectStyle.styles';
import { data, LoaderFunction } from '@remix-run/node';
import { CreateNewPage } from '~/_models';
import { useLoaderData, useLocation } from '@remix-run/react';
import { DefaultCombination } from '~/utils/Constant';
import get from 'lodash/get';
import { mapToCheckoutStep } from '~/utils/mapper';
import {
  mapToPlateFormatList,
  mapToSweepstakeCampaignList,
} from '~/mappers/PlateFormat/mapper';
import { mapToSEO } from '~/components/SEO/mapper';
import CombinationFinder from '~/components/CombinationFinder/CombinationFinder';
import {
  LOCALSTORAGE_CAMPAIGN_CURRENT,
  LOCALSTORAGE_LEAD,
} from '~/stateManagement/localStorage';
import { BreadCrumb } from '~/components/CombinationFinder/CombinationFinder.styles';
import SEO from '~/components/SEO/SEO';
import { queryItemByCodeName } from '~/utils/kontentClientWrapper';
import { useState } from 'react';
import { useClientEnv } from '~/contexts/ClientEnvContext';
export { headers } from '~/defaults.server';
export const loader: LoaderFunction = async ({ request }) => {
  const createNewPage = await queryItemByCodeName<CreateNewPage>(
    'create_new_plate',
    4,
  );
  console.log(createNewPage);
  return data<CreateNewPage>(createNewPage, {
    headers: {
      'Cache-Control': `public, max-age=${process.env.HTTP_CACHE_MAX_AGE || 300}, stale-while-revalidate=${process.env.STALE_WHILE_REVALIDATE || 3600}`,
    },
  });
};

type CreateNewStates = {
  vehicleType: VehicleType;
  transactionType: TransactionType;
  combination: string;
  plateDesign?: CurrentPlateDesign;
  categoryName?: string;
  isGift?: boolean;
  cleanCampaign: boolean;
  notify?: boolean;
  buynow?: boolean;
  lid?: string;
  email?: string;
  designId: number;
};

const loadFromQuerystring = (location: any): CreateNewStates => {
  if (location.search) {
    const query = queryString.parse(location.search, {
      parseBooleans: true,
      parseNumbers: true,
    });
    const vehicleType = getVehicleTypeByQueryString(
      query.vt as number | undefined,
    );
    const combination = getCombinationByQueryString(
      query.combination as string | undefined,
    );
    const transactionType = getTransactionTypeByQueryString(
      query.tt as number | undefined,
    );
    const isGift = getIsGiftingByQueryString(query.gift as number | undefined);
    const cleanCampaign = getCleanCampaignByQueryString(
      query.clean as number | undefined,
    );
    const email = setEmptyIfUndefiendByQueryString(
      query.email as string | undefined,
    );
    const lid = setEmptyIfUndefiendByQueryString(
      query.lid as string | undefined,
    );
    const designId = getDesignIdByQueryString(
      query.designid as number | undefined,
    );
    const notify = getIsGiftingByQueryString(
      query.notify as number | undefined,
    );
    const buynow = getIsGiftingByQueryString(
      query.buynow as number | undefined,
    );
    return {
      vehicleType: vehicleType,
      transactionType: transactionType,
      combination: combination,
      isGift: isGift,
      cleanCampaign: cleanCampaign,
      notify: notify,
      buynow: buynow,
      email: email,
      lid: lid,
      designId: designId,
    };
  }
  return {
    vehicleType: VehicleTypesSetting.Car,
    transactionType: TransactionTypesSetting.New,
    combination: '',
    isGift: false,
    cleanCampaign: false,
    notify: false,
    buynow: false,
    email: '',
    lid: '',
    designId: 0,
  };
};

const loadCombinationFromState = (
  combination: string,
  vehicleType: VehicleType,
) => {
  if (combination === get(DefaultCombination, vehicleType.name)) {
    return '';
  }
  return combination;
};

const loadFromStates = (states: any): CreateNewStates | undefined => {
  if (states && states.vehicleType && states.transactionType) {
    return {
      vehicleType: states.vehicleType,
      transactionType: states.transactionType,
      combination: loadCombinationFromState(
        states.combination,
        states.vehicleType,
      ),
      plateDesign: states.plateDesign,
      categoryName: states.categoryName,
      isGift: states.isGift,
      cleanCampaign: states.cleanCampaign,
      designId: states.designId,
    };
  }
  return undefined;
};

export const handle = {
  layout: 'simple',
};
const CreatePage = (props: any) => {
  const { elements } = useLoaderData<CreateNewPage>();
  const { apiUrl, reCaptchaSiteKey, reCaptchaSiteKeyV2, emailValidationToken } =
    useClientEnv();
  const location = useLocation();
  const [state, setState] = useState<CreateNewStates>();
  if (isMobile() === undefined) {
    return null;
  }

  // const step = mapToCheckoutStep(elements);
  const seo = mapToSEO(elements);
  const plateFormats = mapToPlateFormatList(elements.plateFormats);
  const sweepstakeCampaign = mapToSweepstakeCampaignList(
    elements.campaignItems,
  )[0];
  const heading = elements.heading.value;
  const states = loadFromStates(location.state);
  const queryData =
    states === undefined ? loadFromQuerystring(location) : states;
  const urlQueryData = loadFromQuerystring(location);
  const alternativeMessage = elements.alternativeMessage.value;
  const isLeadGenEnabled = true; //abTestingCookie === "true";//elements.lead_generation.value[0].name === 'Enable' ? true : false;
  let carMake = elements.carMake.value.map((item: any) => {
    return {
      key: item.name,
      text: item.name,
      value: item.name,
      category: 'car',
    };
  });

  const carmotobikeMake = elements.motorbikeMake.value.map((item: any) => {
    return {
      key: item.name,
      text: item.name,
      value: item.name,
      category: 'motorbike',
    };
  });

  carMake = carMake.concat(carmotobikeMake);

  if (queryData.cleanCampaign) {
    const campaignInLocal: string | null = localStorage.getItem(
      LOCALSTORAGE_CAMPAIGN_CURRENT,
    );
  }

  if (queryData.email != '' || queryData.email != undefined) {
    localStorage.setItem(
      LOCALSTORAGE_LEAD,
      `${queryData.lid}|${queryData.email}`,
    );
  }

  const getArrow = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="7"
        height="13"
        viewBox="0 0 7 13"
        fill="none"
      >
        <path
          d="M6.70719 5.79402C7.09767 6.1845 7.09767 6.81863 6.70719 7.2091L1.70915 12.2071C1.31867 12.5976 0.684547 12.5976 0.294075 12.2071C-0.0963974 11.8167 -0.0963974 11.1825 0.294075 10.7921L4.58615 6.5L0.297199 2.20793C-0.0932737 1.81745 -0.0932737 1.18333 0.297199 0.792854C0.687671 0.402382 1.3218 0.402382 1.71227 0.792854L6.71032 5.7909L6.70719 5.79402Z"
          fill="white"
        />
      </svg>
    );
  };

  return (
    //<LayoutWrapper  version="simple" currentStep={step} location={location}>
    <div>
      <SEO {...seo} />

      <GenericBannerContainer
        padding={{
          mobile: {
            top: 30,
            bottom: 190,
          },
          desktop: {
            top: 50,
            bottom: 80,
          },
        }}
        backgroundColor="black"
      >
        <Grid>
          <Grid.Row>
            <Grid.Column width={16} textAlign="right">
              <div className="block md:hidden">
                <HeaderStep>Step 1/3</HeaderStep>
              </div>
              <div className="hidden md:block">
                <BreadCrumb>
                  <span>Plate Search</span>
                  {getArrow()}Select Design{getArrow()}Finalise Plate
                </BreadCrumb>
              </div>
            </Grid.Column>
            <Grid.Column width={16} textAlign="left">
              {isMobile() ? (
                <H2 color="white">{heading}</H2>
              ) : (
                <H2 color="white">{heading}</H2>
              )}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <CombinationFinder
                vehicleType={queryData.vehicleType}
                transactionType={queryData.transactionType}
                combination={queryData.combination}
                isGift={queryData.isGift}
                plateDesign={queryData.plateDesign}
                plateformats={plateFormats}
                categoryName={queryData.categoryName}
                apiUrl={apiUrl}
                title=""
                alternativeMessage={alternativeMessage}
                reCaptchaSiteKey={reCaptchaSiteKey}
                reCaptchaSiteKeyV2={reCaptchaSiteKeyV2}
                campaign={sweepstakeCampaign}
                emailValidationToken={emailValidationToken}
                isLeadGenEnabled={isLeadGenEnabled}
                buynow={queryData.buynow}
                notify={queryData.notify}
                carMake={carMake}
                email={queryData.email}
                lid={queryData.lid}
                designId={queryData.designId}
                darkTheme={true}
              ></CombinationFinder>
            </Grid.Column>
            <Grid.Column width={6}></Grid.Column>
          </Grid.Row>
        </Grid>
      </GenericBannerContainer>
    </div>
  );
};

export default CreatePage;
